import axios from 'axios'
import router from '@/router'
import store from '@/store'
import { Loading } from 'element-ui'
import { errorMsg } from '@/plugins/message'

let apiCount = 0
let loadingInstance = null
function displayLoading (show) {
  show ? apiCount++ : apiCount--

  apiCount
    ? loadingInstance = Loading.service({ lock: true })
    : loadingInstance.close()
}

// helper function
const redirectLoginPage = () => {
  router.replace({
    path: '/login',
    query: {
      redirect: router.currentRoute.fullPath
    }
  })
}

const _instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 100000
})

_instance.interceptors.request.use(config => {
  const token = store.state.token
  token && (config.headers.Authorization = `Bearer ${token}`)
  return config
}, error => Promise.reject(error))

_instance.interceptors.response.use(response => {
  if (response.status === 200) return response.data

  return Promise.reject(response.data)
}, error => {
  let errorMessage = ''
  if (error.response && error.response.status) {
    switch (error.response.status) {
      case 401:
        redirectLoginPage()
        break

      case 403:
        errorMessage = `操作錯誤(${error.response.data.message})`
        break

      case 404:
        if (error.config.method === 'get') {
          errorMessage = '找無此頁面'
        }
        break
    }
  }

  if (!error.config.silenceErrorMsg) {
    errorMsg(errorMessage || error.response.data.message)
  }

  return Promise.reject(error.response.data)
})

function request (method, url, params, data, option = {}) {
  const config = {
    method,
    url,
    params,
    data,
    ...option
  }

  displayLoading(true)

  return _instance.request(config)
    .then(res => res.data || res)
    .finally(() => {
      displayLoading(false)
    })
}

export const get = (url, params, option) => {
  return request('get', url, params, null, option)
}

export const post = (url, payload, option) => {
  return request('post', url, null, payload, option)
}

export const put = (url, payload, option) => {
  return request('put', url, null, payload, option)
}

export const remove = (url, params, option) => {
  return request('delete', url, params, null, option)
}

export default {
  get,
  post,
  put,
  delete: remove
}
